<template>
  <el-select
    :clearable="clearable"
    :size="size"
    :disabled="disabled"
    :placeholder="placeholder"
    class="icon-select"
    @input="onInput"
    :value="value"
  >
    <el-option
      v-for="(item, index) in data"
      :key="index"
      :label="item.value"
      :value="item.value"
    >
      <span class="icon-select-name">{{ item.value }}</span>
      <span class="icon-select-preview">
        <i class="icon" :class="item.value"></i>
      </span>
    </el-option>
  </el-select>
</template>

<script>
const cache = {
  componentData: [],
  modelData: []
};

export default {
  props: {
    size: { type: String, default: 'small' },
    value: [String, Number],
    // component:产品组件图标   model:产品物模型图标
    type: { type: String, default: 'component' },
    placeholder: String,
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    // 字典code
    code: { type: String, default: 'conponents_icon' }
  },
  computed: {
    data() {
      return this.cache[this.code] || [];
    }
  },
  data() {
    return {
      cache
    };
  },
  mounted() {
    if (!this.cache[this.code]) {
      this.getDictionary(this.code, (dictionary) => {
        this.$set(cache, this.code, dictionary[this.code]);
      });
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val);
    }
  }
};
</script>

<style lang="scss">
.icon-select {
  width: 100%;
}

.icon-select-name {
  float: left;
}

.icon-select-preview {
  float: right;

  .icon {
    font-size: 14px;
  }
}
</style>
